export default () => ({
  showSearchMessage: false,
  showHandoff: false,
  showChannelControl: false,
  showTestResultModal: false,
  showFilters: false,
  mixedDataError: false
})
